module.exports = __webpack_public_path__ + "images/emoji/heavy_minus_sign.11d6c9edf517e627646e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heavy_minus_sign.png
// module id = WyFj
// module chunks = 14